export function PortalDashboard() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-text mb-6">My Portal</h1>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-surface p-4 rounded-xl border border-border">
          <h3 className="font-semibold text-primary mb-2">My Appointments</h3>
          <p className="text-text-muted text-sm">View upcoming appointments</p>
        </div>
        <div className="bg-surface p-4 rounded-xl border border-border">
          <h3 className="font-semibold text-primary mb-2">My Visits</h3>
          <p className="text-text-muted text-sm">View visit history</p>
        </div>
        <div className="bg-surface p-4 rounded-xl border border-border">
          <h3 className="font-semibold text-primary mb-2">My Bills</h3>
          <p className="text-text-muted text-sm">View and pay bills</p>
        </div>
      </div>
    </div>
  )
}
